import { render } from "./MoveImsiDialog.vue?vue&type=template&id=2845dd7e&scoped=true"
import script from "./MoveImsiDialog.vue?vue&type=script&lang=js"
export * from "./MoveImsiDialog.vue?vue&type=script&lang=js"

import "./MoveImsiDialog.vue?vue&type=style&index=0&id=2845dd7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2845dd7e"]])

export default __exports__